import {
    createBrowserRouter,
    Link,
  } from "react-router-dom";
import Home from "./Pages/Home";
import Work from "./Pages/Work";
import Services from "./Pages/Services"
import Contact from "./Pages/Contact";
import Packages from "./Pages/Packages";




const router = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "work",
      element: <Work />
    },
    {
      path: "services",
      element: <Services />
    },
    {
      path: "packages",
      element: <Packages />
    },
    {
      path: "contact",
      element: <Contact />
    }
  ]);

  export default router;